export default function isValueDifferent(firstValue = "", secondValue = ""): boolean {
	const normalize = (value: string): string => {
		const stringValue = String(value).trim().toLowerCase();

		if (stringValue === "nc") return ""; // "NC" === ""

		const numericValue = Number.parseFloat(stringValue.replace(",", "."));
		if (!isNaN(numericValue)) {
			return numericValue.toFixed(2); // "1.20" === "1.2"
		}

		return (
			stringValue
				.normalize("NFD")
				.replace(/\p{M}/gu, "") // é === e
				.replace(".", ",")
		); // 1.20 === 1,20
	};

	const normalizedFirstValue = normalize(firstValue);
	const normalizedSecondValue = normalize(secondValue);

	return normalizedFirstValue !== normalizedSecondValue;
}